import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Client } from 'src/app/models/client';
import { ClientService, WorkflowContextService } from 'src/app/services';
import { ModalConfirmComponent } from '../../system/modal-confirm/modal-confirm.component';

@Component({
  selector: 'wm-copy-workflow-settings',
  templateUrl: './copy-workflow-settings.component.html',
  styleUrl: './copy-workflow-settings.component.css',
  standalone: false
})
export class CopyWorkflowSettingsComponent implements OnInit {
  @ViewChild('confirmChangeTargetModal') confirmChangeTargetModal: ModalConfirmComponent;
  
  clients: Client[];
  workflowId: string;
  targetClientId: string;
  changingTargetClient = false;
  fallbackClientId: string;
  firstTargetClientSelectionMade = false;

  constructor(
    private _route: ActivatedRoute,
    private _context: WorkflowContextService,
    private _clientSvc: ClientService
  ) { }

  ngOnInit() {
      this._clientSvc.getAdminClients().subscribe(clients => {

      this.clients = clients.filter(c => c.id !== this._context?.client?.id);

      this.clients.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      )

      this._route.params.subscribe(params => {
        if (params['workflowId']) {
          this.workflowId = params['workflowId'];
        }
      });
    });
  }

  switchTargetClients() {
    this.changingTargetClient = true;
    setTimeout(() => {
      this.fallbackClientId = this.targetClientId;
      
      this.changingTargetClient = false;
    }, 200);
  }

  cancelSwitchTargetClients() {
    this.targetClientId = this.fallbackClientId;
  }

  targetClientSelectionChanged(event) {
    if (this.fallbackClientId === undefined) {
      this.fallbackClientId = this.targetClientId;
    }

    if (this.firstTargetClientSelectionMade) {
      //open warning modal
      this.confirmChangeTargetModal.open();
    } else {
      this.firstTargetClientSelectionMade = true;
    }
  }
}
